import api from '../constants/api';
import {alignTableCenter,alignTableLeft} from '../utils';
import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";
export default{
    data(){
        return {
            isNumPnotice: 0,
            istrr: true,
            isSizePnotice:0,
            items:[],
            totalsNum:0,
            popupsDetail:[],
            popups:[],
            thisIds:[],
            search: '',
            lastPage: 1,
            searchValue : '제목',
            total: 1,
            perPage: 5,
            currentPage: 1,
            searchPlaceholder:'검색',
            fields:[
                {key: 'noticeNo', label: "번호", ...alignTableCenter},
                // {key: 'registeredBy', label: "작성자", ...alignTableCenter},
                {key: 'title', label: "제목", ...alignTableLeft},
                {key: 'registeredDate', label: "작성일", ...alignTableCenter},
            ],
            searchOption: [
                {label: "제목", value: "TitleContaining"},
                // {label: "전체", value: "NoKeyword"},
                // {label: "작성자", value: "RegisteredBy"}
            ],
        }
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName'])
        },
    mounted(){
        this.initPopup();
    },
    methods:{
        hideModal(noticeNo){
            // alert(noticeNo)
            const con = document.getElementById(noticeNo);
            con.style.display = 'none';
            
        },
        //팝업 초기화면
        initPopup(){
            this.popups = [];
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.border.borderPopup);
            this.$http.get(reqURL, {
                headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
            }).then(res => {
                if(res.data.code === "OK") {
                const _data = res.data.data
                this.popups = _data.list
                // console.log(this.popups)
                // return;
                } else {
                throw 400
                }
            }).catch(err => {
                console.log(err);
            })
        },
        //팝업 상세
        popupsDetailPopup(paramsss){
            this.popupsDetail = [];
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.border.borderDetaile);
            const params = {
                noticeNo : paramsss
            }
            this.$http.post(reqURL,params, {
                headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
            }).then(res => {
                if(res.data.code === "OK") {
                const _data = res.data.data
                this.popupsDetail = _data
                // console.log(this.popupsDetail)
                // return;
                } else {
                throw 400
                }
            }).catch(err => {
                console.log(err);
            })
        },
        //팝업 페이징
        popupPageing(){
            this.popupsList = [];
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.border.borderList);

            let _keywordType = this.search === "" ? "NoKeyword" : "TitleContaining"  //키워드 내용없을경우
            const params = {
                keywordType : _keywordType,
                keyword : this.search,
                publishedOnly : true,
                pageNumber : (this.currentPage - 1),
                pageSize : this.perPage
            }
            this.$http.post(reqURL,params, {
                headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
            }).then(res => {
                if(res.data.code === "OK") {
                const _data = res.data.data
                this.lastPage = res.data.data.totalPages;
                this.total = res.data.data.totalElements;
                console.log(_data)
                this.isNumPnotice = _data.number
                this.isSizePnotice = _data.size
                this.items = _data.content;
                this.totalsNum = _data.totalElements;
                this.items.forEach(popup => popup.id = popup.noticeNo);
                for(let i = 0; i < this.items.length; i++) {
                    this.thisIds.push(this.items[i].id);
                    // console.log(this.items[i].length)
                }
                // console.log(this.popupsList);
                // alert(this.thiiIds)
                } else {
                throw 400
                }
            }).catch(err => {
                console.log(err.response.data.message);
            })
        },
    }
}